// extracted by mini-css-extract-plugin
export default {"popup":"IxqsMbjsLDLuNALZTUtv","text":"nGq0WaZXCkaDt3278k_A","imageSrc":"Nr3zkQl8hjAL_SmYlekQ","closeIcon":"PpF3QkfwxqhBXX4AyGLM","textContainer":"Md3RT3t4hmzD7YhbGrQ2"};